import { z } from 'zod';

export const registrationStepFiveSchema = z.object({
    regions: z.array(z.object({ label: z.string(), value: z.number() })).nullable(),
    looks_for: z.enum(['male', 'female', 'any'], { message: 'Пол обязателен' }),
    min_age: z.number(),
    max_age: z.number(),
});

export type RegistrationStepFiveType = z.infer<typeof registrationStepFiveSchema>;
